import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { StateService, AuthService, RoleService } from '../../services';
import { Authenticate, RoleModel } from '../../models';
import { FormFunctions } from '../../functions';
import { state } from '@angular/animations';

@Component({
    selector: 'page-profile',
    templateUrl: './page-profile.component.html',
    styleUrls: ['./page-profile.component.scss']
})
export class PageProfileComponent implements OnInit {
    status: string = "";
    processing: boolean = false;

    constructor(public router: Router, private activatedRoute: ActivatedRoute, public stateService: StateService, public authService: AuthService, public formFunctions: FormFunctions, public roleService: RoleService) {
        var me = this;
    }

    ngOnInit() {
        var me = this;
    }

    SetStatus($event) {
        this.status = $event;
    }
}
